import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DispensariesStateModule } from './dispensaries/dispensaries.state.module';

@NgModule({
	imports: [CommonModule, DispensariesStateModule],
	providers: [],
})
export class StateModule {}
